export default __webpack_public_path__ + "static/media/vuejs.f1fd23be.svg";